import useSWR from 'swr';

const PERMISSIONS = ['user_invoice.update', 'user_invoice.mandant.update'];

/**
 * Editing a Mandant needs either right, switching its chart only the dedicated one.
 * `useCheckPermissions` demands all of its permissions at once, so it cannot express "one of".
 */
export const useMandantPermissions = (clubSlug?: string | null) => {
    const { data, isLoading } = useSWR<{ data: Record<string, boolean> }>(
        clubSlug ? [`clubs/${clubSlug}/permissions`, { permissions: PERMISSIONS }] : null,
        { revalidateOnFocus: false }
    );

    const granted = data?.data ?? {};

    return {
        canEdit: !!granted['user_invoice.update'] || !!granted['user_invoice.mandant.update'],
        canConvert: !!granted['user_invoice.mandant.update'],
        isLoading
    };
};

export default useMandantPermissions;
